import { Link, type LinkProps } from '@linktr.ee/arbor/components/Link';
import type { ReactElement } from 'react';

interface AuthLinkProps extends Omit<LinkProps, 'asChild' | 'children'> {
  /** The actual anchor or button element (rendered via Link asChild). */
  children: ReactElement;
}

/**
 * House defaults for Arbor Link on auth screens: body-small size with
 * the design system's accent color and hover-underline treatment. One
 * construction for every link-styled action (Forgot password/username,
 * Sign up/Log in toggles, "Use a different email") so link styling
 * can't drift per screen.
 */
const AuthLink = ({ size = 'sm', children, ...props }: AuthLinkProps) => (
  <Link asChild size={size} {...props}>
    {children}
  </Link>
);

export default AuthLink;
